import postCreateSummary from "@/services/postCreateSummary";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export interface CreateSummaryData {
  recordingId: string;
}

const usePostCreateSummary = () => {
  const { mutate, mutateAsync, isPending, isError, error, isSuccess, status } = useMutation<boolean, AxiosError, CreateSummaryData>({
    mutationFn: async (data: CreateSummaryData) => {
      const result = await postCreateSummary(data);
      if (result instanceof AxiosError) {
        throw result;
      }

      return result;
    },
    mutationKey: ["postCreateSummary"],
    onError: (error: AxiosError) => {
      reportError({
        eventName: "POST-CREATE-SUMMARY",
        properties: {
          reason: `Error with create summary - ${error?.message}`,
        },
      });
    },
  });

  return { mutate, mutateAsync, isPending, isError, error, isSuccess, status };
};

export default usePostCreateSummary;
